import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import '../../styles.css';

import { sendOtp } from '../../redux/slices/customerAuthSlice'; // Import forgotPassword action

import bgSignin from '../../images/bg-signin.jpg';
import logo from '../../images/logo-agc.png';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
   const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.customer_auth);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status !== 'loading') {
      const response = await dispatch(sendOtp(email));

      if (response.payload && response.payload.status === 'Success') {
        setSuccessMessage(null);
        setErrorMessage(null);
        navigate('/verify-otp');
      } else if (response.payload && response.payload.status === 'Error') {
        setErrorMessage(response.payload.message);
        setSuccessMessage(null);
      } else {
        setErrorMessage('Unexpected error occurred. Please try again.');
        setSuccessMessage(null);
      }
    }
  };

  return (
    <div className="dashboard-container" id="app-body">
      <div className="bg-signin page-signin" style={{ backgroundImage: `url(${bgSignin})` }}>
        <div className="main-body justify-between">
          <div className="form-body">
            <div className="form-body-container">
              <section id="form" className="form">
                <form method="POST" id="forgotPasswordForm" onSubmit={handleSubmit}>
                  <div className="logo-signin">
                    <img src={logo} alt="logo" />
                  </div>
                  
                  <div className="form-sigin-wrap">
                    <h3>Forgot Your Password?</h3>
                    <p>Enter your email address to receive an OTP.</p>
                    
                    {/* Display success or error message if it exists */}
                    {successMessage && (
                      <div className="alert alert-success">
                        {successMessage}
                      </div>
                    )}
                    {errorMessage && (
                      <div className="alert alert-danger">
                        {errorMessage}
                      </div>
                    )}

                    <div className="form-group flex flex-col align-start">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="Your Email"
                        value={email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <button type="submit" className="btn">Send OTP</button>
                    </div>
                    <div className="form-group flex justify-end">
                      <Link className="back-to-login" to="/login">Back to Login</Link>
                    </div>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
        <div className="text-center">
          <p className="text-muted">© 2024 AlexGambleCoaching. Crafted with <i className="mdi mdi-heart text-primary"></i></p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;